import MeApi from '@/api/merchant-me'
import { sortedTree } from '@/libs/utils/array-utils'

const state = {
  menus: null,
  permissions: null,
  merchantInfo: null
}

const mutations = {
  SET_MENUS: (state, menus) => {
    state.menus = menus
  },
  SET_PERMISSIONS: (state, permissions) => {
    state.permissions = permissions
  },
  SET_MERCHANT_INFO: (state, merchantInfo) => {
    state.merchantInfo = merchantInfo
  }
}

const actions = {
  async getPermissions ({ commit }) {
    const result = await MeApi.getPermissions()
    if (result != null) {
      let permissions = {}
      result.forEach(permission => {
        permissions[permission['permissionKey']] = permission
      })
      commit('SET_PERMISSIONS', permissions)
    }
    return result
  },
  async getPermissionGroups ({ commit }) {
    const result = await MeApi.getAllPermissionGroups()
    return result
  },
  async getPermissionGroupsTree ({ commit }, permissionGroups) {
    return sortedTree(permissionGroups, 'groupParent', 'groupSort')
  },
  async getMenus ({ commit }) {
    const result = await MeApi.getMenus()
    if (result != null) {
      commit('SET_MENUS', result)
    }
    return result
  },
  async tree ({ dispatch, commit }, menus) {
    return sortedTree(menus, 'parentId', 'sortBy')
  },
  async getRole ({ commit }) {
    const result = await MeApi.getRole()
    return result
  },
  async getMerchantInfo ({ commit }) {
    try {
      const result = await MeApi.getMerchantInfo()
      if (result) {
        // 确保使用新对象，触发响应式更新
        commit('SET_MERCHANT_INFO', Object.assign({}, result))
      } else {
        // 如果结果为空，设置为 null，避免显示旧数据
        commit('SET_MERCHANT_INFO', null)
      }
      return result
    } catch (error) {
      // 检查是否是 token 格式错误
      if (error.message && error.message.includes('3 parts')) {
        // Token 格式错误，不抛出错误，避免路由守卫循环
        commit('SET_MERCHANT_INFO', null)
        // 不抛出错误，让路由守卫处理
        return null
      }
      // 出错时设置为 null
      commit('SET_MERCHANT_INFO', null)
      throw error
    }
  },
  async saveMerchantInfo ({ commit }, data) {
    const result = await MeApi.saveMerchantInfo(data)
    if (result) {
      commit('SET_MERCHANT_INFO', result)
    }
    return result
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/merchant-me.js